import { Box, Button, Card, CardContent, Skeleton, Stack, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { OrderInfo } from "../shared/orderInfo/types";
import { OrderInfoStack } from "../taskManagement/orderInfo/styles";
import Order from "./Order";
import Properties from "./Properties";

const OrderDetails = ({ orderInfo, isCondensed }: { orderInfo: OrderInfo | null; isCondensed: boolean }) => {
  return (
    <>
      <Stack direction="row" marginBottom={0} sx={{ overflow: "auto" }}>
        <Card
          sx={{
            backgroundColor: isCondensed ? "rgba(0, 0, 0, 0.02)" : "transparent",
            borderRadius: 0,
            borderRight: isCondensed ? "1px solid rgba(0, 0, 0, 0.18)" : "none",
            boxShadow: 0,
            overflow: "auto",
            padding: 0,
            width: "100%",
            fontSize: { sm: "0.7rem", lg: "0.875rem" }
          }}
        >
          <CardContent sx={{ padding: 0 }} style={{ paddingBottom: 0 }}>
            <OrderInfoStack
              direction={isCondensed ? "column" : "row"}
              spacing={isCondensed ? 0 : 3}
              isCondensed={isCondensed}
            >
              <Stack direction="column" sx={{ justifyContent: "space-between" }}>
                <Stack direction="row" alignItems="flex-start" className="customCard customCard-blue">
                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", lg: "1.3rem" }
                    }}
                    fontWeight={600}
                    color="primary"
                  >
                    {orderInfo?.titleCode} {orderInfo?.number}
                    {!orderInfo && <Skeleton height={40} width={200} />}
                  </Typography>
                </Stack>
                <Order orderInfo={orderInfo}/>
              </Stack>
              <Properties orderInfo={orderInfo}/>
            </OrderInfoStack>
          </CardContent>
        </Card>
      </Stack>
    </>
  );
};

export default OrderDetails;
